<div *ngIf="theme?.comments" class="box mb-2 comments">{{ theme?.comments }}</div>

<div [routerLink]="['/k', theme?.id, 'wheel']" class="box pointer mb-2">
  <h3>Wheel</h3>
  <p>
    {{ I18ns.wheel.explanation }}
  </p>
</div>

<div [routerLink]="['/k', theme?.id, 'melo']" class="box pointer mb-2">
  <h3>Melo</h3>
  <p>
    {{ I18ns.melo.explanation }}

  </p>
</div>

<a
  [href]="'mailto:?body=' + I18ns.addTheme.shareMail + URL + '/k/' + theme?.id"
  class="btn mail-btn"
  style="margin-right: 1rem"
  target="_blank"
>
  <svg
    fill="#ffffff"
    height="30px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
    />
  </svg>
</a>
